import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../../core/services/Common/common.service';
import { HelperService } from '../../core/services/Helper/helper.service';

@Component({
  selector: 'app-payment-redirection',
  templateUrl: './payment-redirection.component.html',
  styleUrls: ['./payment-redirection.component.scss']
})
export class PaymentRedirectionComponent implements OnInit {

  messageType:any = '';

  constructor(private activatedRoute: ActivatedRoute,private router: Router,) {
  
    this.messageType = '';

    this.activatedRoute.queryParams.subscribe(params => {
      const message = params['message'];
      this.messageType = message;
     
      
      // // Remove the 'message' parameter from the URL
      // const urlTree = this.router.createUrlTree([], {
      //   queryParams: { ...params, message: null },
      //   queryParamsHandling: 'merge',
      //   preserveFragment: true
      // });
      // this.router.navigateByUrl(urlTree);
    });
   }

  ngOnInit(): void {
  }



}
